import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopeOpenSolidTemplate from './envelope-open-solid-template-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopeOpenSolidTemplate {...validProps} />;
}

SvgComponent.iconName = 'envelopeOpenSolidTemplate';

export const EnvelopeOpenSolidTemplateIcon = svgIconWrapper(SvgComponent);
